<section class="agentic-bot-demo section-spacing">
  <div class="agentic-bot-demo__wrapper">
    <div class="agentic-bot-demo__header">
      <h2>Other Agentic Bot Features</h2>
      <p class="agentic-bot-demo__subtitle">
        Pick a feature and see how the agent handles it inside the ticket surface.
      </p>
    </div>

    <div
      class="agentic-bot-demo__grid"
      (mouseenter)="setPointerInside(true)"
      (mouseleave)="setPointerInside(false)"
      (focusin)="onFocusIn()"
      (focusout)="onFocusOut($event)"
    >
      <div
        #stage
        class="agentic-bot-demo__stage"
        [style.--panel-scale]="scale()"
        aria-hidden="true"
      >
        <div class="bot-panel">
          <div class="bot-panel__topbar">
            <span class="bot-panel__workspace">My Workspace</span>
            <div class="bot-panel__topbar-actions">
              <span class="bot-panel__tour">
                <img [src]="iconBase + 'tour.svg'" alt="" width="11" height="14" loading="lazy" />
                Take a tour
              </span>
              <span class="bot-panel__divider"></span>
              <svg class="bot-panel__glyph" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" />
                <circle cx="12" cy="12" r="4" />
                <path
                  d="m4.93 4.93 4.24 4.24M14.83 9.17l4.24-4.24M14.83 14.83l4.24 4.24M9.17 14.83l-4.24 4.24"
                />
              </svg>
              <img
                [src]="iconBase + 'topbar-apps.svg'"
                alt=""
                width="15"
                height="15"
                loading="lazy"
              />
              <svg class="bot-panel__glyph" viewBox="0 0 24 24">
                <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10.3 21a1.94 1.94 0 0 0 3.4 0" />
              </svg>
              <span class="bot-panel__user">
                <span class="bot-panel__avatar">A</span>
                <svg class="bot-panel__glyph bot-panel__glyph--sm" viewBox="0 0 24 24">
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </span>
            </div>
          </div>

          <div class="bot-panel__rail">
            <div class="bot-panel__rail-top">
              <span class="bot-panel__logo">
                <img [src]="iconBase + 'logo.svg'" alt="" width="23" height="13" loading="lazy" />
              </span>
              @for (n of [1, 2, 3, 4, 5, 6, 7]; track n) {
                <span class="bot-panel__rail-item" [class.is-current]="n === 1">
                  <img
                    [src]="iconBase + 'nav-' + n + '.svg'"
                    alt=""
                    width="18"
                    height="18"
                    loading="lazy"
                  />
                </span>
              }
            </div>
            <span class="bot-panel__rail-item">
              <img
                [src]="iconBase + 'nav-settings.svg'"
                alt=""
                width="18"
                height="18"
                loading="lazy"
              />
            </span>
            <span class="bot-panel__collapse">
              <svg viewBox="0 0 24 24">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3" />
              </svg>
            </span>
          </div>

          <div class="bot-panel__subrail">
            @for (name of ['subnav-1', 'subnav-2', 'subnav-3', 'subnav-4']; track name) {
              <span class="bot-panel__rail-item">
                <img
                  [src]="iconBase + name + '.svg'"
                  alt=""
                  width="18"
                  height="18"
                  loading="lazy"
                />
              </span>
            }
            <span class="bot-panel__rail-item bot-panel__rail-item--bot">
              <img
                [src]="iconBase + 'subnav-bot.svg'"
                alt=""
                width="17"
                height="18"
                loading="lazy"
              />
            </span>
          </div>

          <div class="bot-panel__threads">
            <span class="bot-panel__threads-title">Agentic Bot</span>
            <span class="bot-panel__search">
              <svg viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.3-4.3" />
              </svg>
              Search…
            </span>
            <span class="bot-panel__new-chat">
              <img [src]="iconBase + 'new-chat.svg'" alt="" width="11" height="11" loading="lazy" />
              New chat
            </span>
            <div class="bot-panel__thread-list">
              @for (label of threads(); track label) {
                <span class="bot-panel__thread" [class.is-active]="label === active().thread">
                  {{ label }}
                </span>
              }
            </div>
          </div>

          <div class="bot-panel__chat">
            @for (key of runKey(); track key) {
              @let cap = active();
              @let p = phase();
              <div class="bot-exchange">
                <div class="bot-exchange__user">
                  <span
                    class="bot-exchange__bubble"
                    [class.bot-exchange__bubble--fit]="cap.fitBubble"
                    [class.is-in]="p >= 1"
                  >
                    {{ cap.prompt }}
                  </span>
                </div>

                <div class="bot-exchange__agent" [class.is-in]="p >= 2">
                  <div class="bot-exchange__meta">
                    <svg class="bot-exchange__caret" viewBox="0 0 24 24">
                      <path d="m9 18 6-6-6-6" />
                    </svg>
                    <span class="bot-exchange__name">
                      <img
                        [src]="iconBase + 'agent.svg'"
                        alt=""
                        width="13"
                        height="13"
                        [class.is-spinning]="p >= 2 && p < 4"
                      />
                      Infraon-ITSM
                    </span>
                    <span class="bot-exchange__sep"></span>
                    <span>{{ status() }}</span>
                    <span
                      class="bot-exchange__sep bot-exchange__fade"
                      [class.is-in]="p >= 4"
                    ></span>
                    <span class="bot-exchange__fade" [class.is-in]="p >= 4">{{
                      cap.duration
                    }}</span>
                  </div>
                  <div class="bot-exchange__done bot-exchange__fade" [class.is-in]="p >= 4">
                    <svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5" /></svg>
                    {{ cap.doneLabel }}
                  </div>

                  <p class="bot-exchange__intro bot-exchange__rise" [class.is-in]="p >= 5">
                    {{ cap.intro }}
                  </p>

                  <div class="bot-card bot-exchange__rise" [class.is-in]="p >= 6">
                    @if (cap.card.kind === 'fields') {
                      <div class="bot-card__head">
                        <svg viewBox="0 0 24 24">
                          <rect x="2" y="5" width="20" height="14" rx="2" />
                          <circle cx="8" cy="12" r="2" />
                          <path d="M14 10h4M14 14h4" />
                        </svg>
                        <span class="bot-card__title">{{ cap.card.title }}</span>
                        <span class="bot-card__badge">{{ cap.card.badge }}</span>
                      </div>
                      <div class="bot-card__fields">
                        @for (field of cap.card.fields; track field[0]; let i = $index) {
                          <div
                            class="bot-card__field bot-card__item"
                            [style.transition-delay.ms]="i * 90"
                          >
                            <span class="bot-card__key">{{ field[0] }}</span>
                            <span class="bot-card__value">{{ field[1] }}</span>
                          </div>
                        }
                      </div>
                      @if (cap.card.actions) {
                        <div class="bot-card__actions bot-exchange__fade" [class.is-in]="p >= 7">
                          <span class="bot-card__btn bot-card__btn--primary">Confirm</span>
                          <span class="bot-card__btn">Edit fields</span>
                          <span class="bot-card__btn">Assign to me</span>
                        </div>
                      }
                    } @else if (cap.card.kind === 'list') {
                      @for (item of cap.card.items; track item.title; let i = $index) {
                        <div
                          class="bot-card__row bot-card__item"
                          [style.transition-delay.ms]="i * 90"
                        >
                          <span class="bot-card__mark">{{ item.mark }}</span>
                          <span class="bot-card__row-text">
                            <span class="bot-card__row-title">{{ item.title }}</span>
                            <span class="bot-card__row-sub">{{ item.sub }}</span>
                          </span>
                          <span class="bot-card__tag bot-card__tag--{{ item.tone }}">{{
                            item.tag
                          }}</span>
                        </div>
                      }
                    } @else if (cap.card.kind === 'table') {
                      <div class="bot-card__table-row bot-card__table-row--head">
                        <span>Request</span>
                        <span>Summary</span>
                        <span>State</span>
                        <span>Priority</span>
                        <span>Owner</span>
                      </div>
                      @for (row of cap.card.rows; track row[0]; let i = $index) {
                        <div
                          class="bot-card__table-row bot-card__item"
                          [style.transition-delay.ms]="i * 90"
                        >
                          <span class="bot-card__id">{{ row[0] }}</span>
                          <span class="bot-card__summary">{{ row[1] }}</span>
                          <span>{{ row[2] }}</span>
                          <span>{{ row[3] }}</span>
                          <span class="bot-card__owner">{{ row[4] }}</span>
                        </div>
                      }
                    }
                  </div>

                  <span class="bot-exchange__foot bot-exchange__fade" [class.is-in]="p >= 7">
                    {{ cap.foot }}
                  </span>
                </div>
              </div>
            }
          </div>

          <div class="bot-panel__input">
            <span class="bot-panel__input-text" [class.is-typing]="isTyping()">
              {{ inputText() }}<span class="bot-panel__cursor" [class.is-on]="isTyping()"></span>
            </span>
            <span
              class="bot-panel__send"
              [class.is-ready]="isTyping()"
              [class.is-pressed]="sendPressed()"
            >
              <svg viewBox="0 0 24 24"><path d="m5 12 7-7 7 7M12 19V5" /></svg>
            </span>
          </div>
        </div>
      </div>

      <div class="agentic-bot-demo__caps">
        @for (cap of capabilities; track cap.label; let i = $index) {
          <div class="agentic-bot-demo__cap" [class.is-active]="i === step()">
            <button
              type="button"
              class="agentic-bot-demo__cap-head"
              [attr.aria-expanded]="i === step()"
              [attr.aria-controls]="'agentic-bot-cap-' + i"
              (click)="select(i)"
            >
              <svg class="agentic-bot-demo__cap-icon" viewBox="0 0 24 24" aria-hidden="true">
                @switch (cap.icon) {
                  @case ('tag') {
                    <path
                      d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"
                    />
                    <circle cx="7.5" cy="7.5" r="1" />
                  }
                  @case ('priority') {
                    <path d="m3 8 4-4 4 4M7 4v16M11 12h10M11 16h7M11 20h4" />
                  }
                  @case ('clone') {
                    <rect x="8" y="8" width="14" height="14" rx="2" />
                    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                  }
                  @case ('plus') {
                    <circle cx="12" cy="12" r="10" />
                    <path d="M8 12h8M12 8v8" />
                  }
                  @case ('user-check') {
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2m14-10 2 2 4-4" />
                    <circle cx="9" cy="7" r="4" />
                  }
                  @case ('search') {
                    <circle cx="11" cy="11" r="8" />
                    <path d="m21 21-4.3-4.3" />
                  }
                }
              </svg>
              <span class="agentic-bot-demo__cap-label">{{ cap.label }}</span>
              <svg class="agentic-bot-demo__cap-icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="m9 18 6-6-6-6" />
              </svg>
            </button>
            <div
              class="agentic-bot-demo__cap-body"
              [id]="'agentic-bot-cap-' + i"
              [attr.aria-hidden]="i !== step()"
            >
              <div>
                <p class="agentic-bot-demo__cap-desc">{{ cap.description }}</p>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</section>
